export default "__VITE_ASSET__CEBAP$fC__"